import { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { insertStudent } from "../api/studentsService";

const AddStudentComponent = (props) => {
    const navigate = useNavigate();
    const closeRef = useRef();

    const [name, setName] = useState("");
    const [family, setFamily] = useState("");
    const [parentMobile, setParentMobile] = useState("");
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {

    }, []);

    const insertStudentHandler = async (e) => {
        setIsSaving(true);
        try {
            const data = await insertStudent(props.classroomId, name, family, parentMobile);
            props.afterAddStudent(data.student.id, data.student.name, data.student.family);
            setName("");
            setFamily("");
            setParentMobile("");
            closeRef.current.click();
            setIsSaving(false);
        } catch (err) {
            toast(err.response?.data?.message);
            setIsSaving(false);
        }
    };

    const insertStudentClicked = () => {
        insertStudentHandler();
    }

    return (
        <div class="card-body p-0">
            <div class="modal fade" id="addStudentModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h1 class="modal-title fs-5" id="exampleModalLabel">افزودن دانش آموز</h1>
                        </div>
                        <div class="modal-body">
                            <input value={name} className="form-control" type="text" placeholder="نام دانش آموز" onChange={(e) => setName(e.target.value)} />
                            <input value={family} className="form-control mt-3" type="text" placeholder="فامیل دانش آموز" onChange={(e) => setFamily(e.target.value)} />
                            <input value={parentMobile} className="form-control mt-3" type="number" placeholder="موبایل ولی دانش آموز" onChange={(e) => setParentMobile(e.target.value)} />
                        </div>
                        <div class="modal-footer">
                            <button ref={closeRef} type="button" class="btn btn-secondary" data-bs-dismiss="modal">بستن</button>
                            <button type="button" class="btn btn-primary" onClick={() => insertStudentClicked()}>ذخیره</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AddStudentComponent;
